module.exports = __webpack_public_path__ + "img/policia_ministerial_down_selected.7552e1b5.svg";